//#region ../../node_modules/lodash-es/_isPrototype.js
/** Used for built-in method references. */
var objectProto = Object.prototype;
/**
* Checks if `value` is likely a prototype object.
*
* @private
* @param {*} value The value to check.
* @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
*/
function isPrototype(value) {
	var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
	return value === proto;
}
var _isPrototype_default = isPrototype;

//#endregion
export { _isPrototype_default as default };
//# sourceMappingURL=_isPrototype.js.map